
        var result = require("!!../../../../../node_modules/css-loader/index.js!./new-case.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/cases-management/new-case/new-case.component.css
// module id = 606
// module chunks = 0